/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportConnectDailymotionApiKeyMutationRequest, SocialExportConnectDailymotionApiKeyMutationResponse, SocialExportConnectDailymotionApiKey400, SocialExportConnectDailymotionApiKey401, SocialExportConnectDailymotionApiKey403 } from "../models/SocialExportConnectDailymotionApiKey";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportConnectDailymotionApiKey } from "../axios/socialExportConnectDailymotionApiKey";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportConnectDailymotionApiKeyMutationKey = () => [{ url: '/social-export/v1/auth/dailymotion/api-key' }] as const

export type SocialExportConnectDailymotionApiKeyMutationKey = ReturnType<typeof socialExportConnectDailymotionApiKeyMutationKey>

export function socialExportConnectDailymotionApiKeyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SocialExportConnectDailymotionApiKeyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = socialExportConnectDailymotionApiKeyMutationKey()
        return mutationOptions<SocialExportConnectDailymotionApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectDailymotionApiKey400 | SocialExportConnectDailymotionApiKey401 | SocialExportConnectDailymotionApiKey403>, {data: SocialExportConnectDailymotionApiKeyMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return socialExportConnectDailymotionApiKey(data, config)
          },
        })

}

/**
 * @description Creates a client-owned Dailymotion connection using API key credentials instead of OAuth. Assign the connection to stations separately.
 * @summary Connect Dailymotion with a private API key
 * {@link /social-export/v1/auth/dailymotion/api-key}
 */
export function useSocialExportConnectDailymotionApiKey<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportConnectDailymotionApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectDailymotionApiKey400 | SocialExportConnectDailymotionApiKey401 | SocialExportConnectDailymotionApiKey403>, {data: SocialExportConnectDailymotionApiKeyMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SocialExportConnectDailymotionApiKeyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportConnectDailymotionApiKeyMutationKey()

          const baseOptions = socialExportConnectDailymotionApiKeyMutationOptions(config) as UseMutationOptions<SocialExportConnectDailymotionApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectDailymotionApiKey400 | SocialExportConnectDailymotionApiKey401 | SocialExportConnectDailymotionApiKey403>, {data: SocialExportConnectDailymotionApiKeyMutationRequest}, TContext>
          

          return useMutation<SocialExportConnectDailymotionApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectDailymotionApiKey400 | SocialExportConnectDailymotionApiKey401 | SocialExportConnectDailymotionApiKey403>, {data: SocialExportConnectDailymotionApiKeyMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportConnectDailymotionApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectDailymotionApiKey400 | SocialExportConnectDailymotionApiKey401 | SocialExportConnectDailymotionApiKey403>, {data: SocialExportConnectDailymotionApiKeyMutationRequest}, TContext>
      
}